"use client";

import { useEffect, useRef, useState } from "react";
import { Swiper, SwiperRef, SwiperSlide } from "swiper/react";
import { HERO_SLIDES } from "@/views/home/constants";
import SliderArrowButton from "@/components/entities/slider-arrow-button";
import CustomIcon from "@/components/ui/custom-icon";
import S from "./index.module.scss";
import Link from "next/link";

const HeroSlider = () => {
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [isIntroVisible, setIsIntroVisible] = useState(true);
  const swiperRef = useRef<SwiperRef>(null);

  useEffect(() => {
    const introTimeout = window.setTimeout(() => setIsIntroVisible(false), 700);

    return () => window.clearTimeout(introTimeout);
  }, []);

  const handleNext = () => {
    if (swiperRef.current && currentIndex < HERO_SLIDES.length) {
      swiperRef.current.swiper.slideNext();
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrev = () => {
    if (swiperRef.current && currentIndex !== 0) {
      swiperRef.current.swiper.slidePrev();
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <section className={S.hero} data-intro={isIntroVisible}>
      <Swiper
        speed={900}
        className={S.swiper}
        ref={swiperRef}
        onSlideChange={swiper => setCurrentIndex(swiper.activeIndex)}
      >
        {HERO_SLIDES.map((slide, index) => (
          <SwiperSlide key={`${slide.title}-${slide.description}`} className={S.slide}>
            <img
              src={slide.image}
              alt={slide.title}
              className={`${S.background} ${index === 0 ? S.firstSlideBackground : ""}`}
            />
            {index === 0 && (
              <img src="/images/home/hero/background.png" alt="" aria-hidden="true" className={S.introBackground} />
            )}
            <div className={S.content}>
              <div className={S.info}>
                <h1 className={S.title}>{slide.title}</h1>
                <p className={S.description}>{slide.description}</p>
              </div>
              <Link href={`/catalog/${slide.id}`} className={S.explore}>
                <span>Исследовать</span>
                <CustomIcon fileName="icon-chevron" className={S.exploreIcon} />
              </Link>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className={S.controls}>
        <SliderArrowButton
          direction="prev"
          tone="light"
          onClick={handlePrev}
          style={{ opacity: currentIndex === 0 ? 0 : 1 }}
        />
        <SliderArrowButton
          style={{ opacity: currentIndex === HERO_SLIDES.length - 1 ? 0 : 1 }}
          direction="next"
          tone="light"
          onClick={handleNext}
        />
      </div>

      <div className={S.scrollHint}>
        <span>Листайте вниз</span>
        <CustomIcon fileName="icon-arrow" className={S.scrollIcon} />
      </div>
    </section>
  );
};

export default HeroSlider;
